import * as React from 'react';
import classNames from 'classnames';

import styles from './link.module.scss';

export const Link: React.FC<{
    href: string;
    target?: '_blank';
    inheritColor?: boolean;
}> = (props) => {
    const { href, target, children, inheritColor } = props;

    const className = classNames(styles.link, inheritColor && styles.inheritColor);

    return (
        <a href={href} className={className} target={target} rel="noopener noreferrer">
            {children}
        </a>
    );
};
